import { AfterViewInit, Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { DataTableColumn } from '../../../../shared/ui/data-table/data-table.component';
import { Errors, FileService } from '../../../../core';
import { cashpaymentApi } from '../../../../config/api-url';
import { CashpaymentService } from '../../../../core/services/cashpayment.service';

@Component({
  selector: 'app-reward-cash-tab',
  templateUrl: './reward-cash-tab.component.html',
  styleUrls: ['./reward-cash-tab.component.scss'],
})
export class RewardCashTabComponent implements OnInit, AfterViewInit {
  errors: Errors = { errors: {} };

  byUserStatus: any = '';
  fiscalYear: any = '';
  fiscalQtr: any = '';
  byUserPageNo: number = 1;
  byUserSize: number = 3;
  isLoading: boolean = false;
  byUserCashPaymentGridData: any = [];

  byUserStatusList: any[] = [{ id: '', name: 'All' }];
  fiscalYearDropdownItems: any[] = [{ id: '', name: 'All' }];
  fiscalQtrList: any[] = [
    { id: '', name: 'All' },
    { id: 'Q1', name: 'Q1' },
    { id: 'Q2', name: 'Q2' },
    { id: 'Q3', name: 'Q3' },
    { id: 'Q4', name: 'Q4' },
  ];

  @ViewChild('cashStatusTemplate') cashStatusTemplate: TemplateRef<any> = null as any;

  cashPage: number = 1;
  cashTableColumns: DataTableColumn[] = [
    { field: 'fiscalPeriod', header: 'Fiscal Period', align: 'left' },
    { field: 'amount', header: 'Amount (before taxes/fees)', align: 'left' },
    { field: 'statusName', header: 'Status', align: 'left' },
    { field: 'updatedOn', header: 'Updated On', align: 'left' },
  ];

  get cashRows() {
    const content = this.byUserCashPaymentGridData && this.byUserCashPaymentGridData.content
      ? this.byUserCashPaymentGridData.content : [];
    return content.map((item: any) => ({
      fiscalPeriod: 'FY' + item.fiscalYear + ' ' + item.quarter,
      amount: item.amount != null
        ? '$' + item.amount.toLocaleString('en-US', { minimumFractionDigits: 1, maximumFractionDigits: 1 })
        : '-',
      statusName: item.status && item.status.name ? item.status.name : '-',
      statusId: item.status ? item.status.id : null,
      updatedOn: item.status && item.status.updatedOn
        ? new Date(item.status.updatedOn).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
        : '-',
    }));
  }

  constructor(
    private cashPaymentService: CashpaymentService,
    private fileService: FileService,
  ) {}

  ngOnInit() {
    this.generateFiscalYearOptions();
    this.getByuserStatusList();
    this.getcashHistoryGridData();
  }

  ngAfterViewInit() {
    this.cashTableColumns[2].cellTemplate = this.cashStatusTemplate;
  }

  getByuserStatusList() {
    this.cashPaymentService.getSellerStatusList().subscribe((response: any) => {
      this.byUserStatusList = [{ id: '', name: 'All' }, ...response];
    });
  }

  generateFiscalYearOptions(): void {
    const currentYear = new Date().getFullYear();
    const years: any[] = [{ id: '', name: 'All' }];
    for (let i = -2; i <= 1; i++) {
      const year = currentYear + i;
      years.push({ id: year.toString(), name: 'FY' + year });
    }
    this.fiscalYearDropdownItems = years;
  }

  getCurrentSelectedFiscalYear(): any {
    const match = this.fiscalYearDropdownItems.find((item: any) => item.id === this.fiscalYear);
    return match ? match : { id: '', name: 'All' };
  }

  onFiscalYearChange(item: any): void {
    this.fiscalYear = item && item.id ? item.id : '';
  }

  getCurrentSelectedByUserStatus(): any {
    const match = this.byUserStatusList.find((item: any) => item.id === this.byUserStatus);
    return match ? match : { id: '', name: 'All' };
  }

  onByUserStatusChange(item: any): void {
    this.byUserStatus = item && item.id ? item.id : '';
  }

  getCurrentSelectedFiscalQtr(): any {
    const match = this.fiscalQtrList.find((item: any) => item.id === this.fiscalQtr);
    return match ? match : { id: '', name: 'All' };
  }

  onFiscalQtrChange(item: any): void {
    this.fiscalQtr = item && item.id ? item.id : '';
  }

  resetByUserFilters(): void {
    this.byUserStatus = '';
    this.fiscalYear = '';
    this.fiscalQtr = '';
    this.getcashHistoryGridData('reset');
  }

  getcashHistoryGridData(i?: any, eve?: any) {
    let req = '';
    if (i === 'reset') {
      this.byUserPageNo = 1;
      this.byUserSize = 3;
    }
    if (eve) {
      this.byUserPageNo = eve;
    }
    if (this.byUserStatus) {
      req = req + '&status=' + this.byUserStatus;
    }
    if (this.fiscalYear) {
      req = req + '&fiscalYear=' + this.fiscalYear;
    }
    if (this.fiscalQtr) {
      req = req + '&quarter=' + this.fiscalQtr;
    }
    req = req + '&page=' + (this.byUserPageNo - 1) + '&size=' + this.byUserSize;
    this.isLoading = true;
    this.cashPaymentService.getSellerlevelCashData(req).subscribe(
      (response: any) => { this.isLoading = false; this.byUserCashPaymentGridData = response; },
      (err: any) => { this.isLoading = false; this.errors = err; }
    );
  }

  onCashPageChange(page: number) {
    this.cashPage = page;
    this.byUserPageNo = page;
    this.getcashHistoryGridData();
  }

  byUserExportData() {
    const url: string = cashpaymentApi.getByuserConsolidatedData + '&asExcel=true';
    const fileName: string = 'Payment_File.xlsx';
    this.fileService.excelDownloadFile(url, fileName, true);
  }
}
